import { defineStore } from 'pinia';

export const useManifestStore = defineStore('manifest', {
  state: () => ({
    radioValue: 'all',
    searchValue: ''
  }),
  persist: false,
  actions: {}
});
